// extracted by mini-css-extract-plugin
module.exports = {"container":"QRCode_container__36mnb","explanation":"QRCode_explanation__3RKGX","buttonsBox":"QRCode_buttonsBox__1Yvps","btn":"QRCode_btn__3LuHj","title":"QRCode_title__250Uc"};